module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/zh-hant_3-8ffcb10cd739774f76ce3efa7434958b.jpg";